const {BASE_URL, API_VERSION, DISTRIBUTION_BASE_URL} = window.jf;
export default {
    "BASE_URL": "",
    "API_URL": `${BASE_URL}ui/`,
	"API_UI_URL": `${BASE_URL}/${API_VERSION}${DISTRIBUTION_BASE_URL}`,
    "USERS": "/users",
    "LOGIN": "/auth/login",
    "UPLOAD_BASE_URL": "/api/ui/content_upload/"
};



// WEBPACK FOOTER //
// ./modules/distribution/constants/api.constants.js